import { IconCustomTag } from "./icon";
export var ICON_DIRECTIVES = [
    IconCustomTag
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/icon/index.js
// module id = 185
// module chunks = 4